export function formatDate(date: Date) {
  // Want MM/DD/YYYY
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
}

function parseUtcDateString(date: string): Date | null {
  const normalizedDate = /(?:[zZ]|[+-]\d{2}:?\d{2})$/.test(date) ? date : `${date}Z`;
  const parsedDate = new Date(normalizedDate);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
}

export function formatDateString(date: string) {
  const parsedDate = parseUtcDateString(date);
  return parsedDate ? formatDate(parsedDate) : date;
}

export function formatTime(date: Date) {
  return date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}

export function formatDateStringWithTime(date: string) {
  const parsedDate = parseUtcDateString(date);
  return parsedDate ? `${formatDate(parsedDate)} ${formatTime(parsedDate)}` : date;
}
